

const dataSlider = [
  {
    id: 0,
    title: "",
    img: "https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776297/VishvasWebsite/ABOUT%20US/PLANT/Slideshow%20B/xpgfd1gqdxezpvd0d6ug.jpg",

  },
  {
    id: 1,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776295/VishvasWebsite/ABOUT%20US/PLANT/Slideshow%20B/yfezzet9vj1uuuvpfwq0.jpg",
  },
  {
    id: 2,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776296/VishvasWebsite/ABOUT%20US/PLANT/Slideshow%20B/y1snhnggxs2m3cqil5fx.jpg",
  },
  {
    id: 3,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776297/VishvasWebsite/ABOUT%20US/PLANT/Slideshow%20B/evgqrowrcalreqartxgo.jpg",
  },
  {
    id:4,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776297/VishvasWebsite/ABOUT%20US/PLANT/Slideshow%20B/dnchdwiutp1xkz8et4fy.jpg",
  },
  {
    id:5,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776298/VishvasWebsite/ABOUT%20US/PLANT/Slideshow%20B/h56lonegienuf8vzmq6i.jpg",
  },
  {
    id:6,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776297/VishvasWebsite/ABOUT%20US/PLANT/Slideshow%20B/yhn7ul4ulrhqnzpebz1q.jpg",
  },
  {
    id:7,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776297/VishvasWebsite/ABOUT%20US/PLANT/Slideshow%20B/dh24i6zxcny9dyng2mvk.jpg",
  },
  {
    id:8,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776297/VishvasWebsite/ABOUT%20US/PLANT/Slideshow%20B/yf6duji5swzvt5yw2rw0.jpg",
  },
  {
    id:9,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776297/VishvasWebsite/ABOUT%20US/PLANT/Slideshow%20B/j9uf94i7xxre8daljmj4.jpg",
  },
 
];

export default dataSlider;
